<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>ارسال مدارک</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.title.val" :description="form.title.inv" label="عنوان" />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect v-model="form.file_type.val" label="نوع فایل"
                                        :options="[
                                            {value: '1', label: 'تعهدنامه'},
                                            {value: '2', label:'درخواست خطوط خدماتی'},
                                            {value: '3', label:'مدارک شناسایی'},
                                            {value: '4', label:'سایر موارد'},
                                        ]"
                                        :description="form.file_type.inv"
                                        placeholder="انتخاب کنید" @change="form.file_type.val=$event.target.value" />
                                </CCol>
                                <CCol sm="3">
                                    <CInputFile label="آپلود فایل"
                                        @change="form.file.val=$event[0]"
                                        :description="form.file.inv"
                                    />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> ارسال</CButton>
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
                title: { val: '', inv: '', v: { req: true, max: 256 } },
                file_type: { val: '', inv: '', v: { req: true, max: 4 } },
                file: { val: '', inv: '', v: { req: true } },
            },
            disable: false,
            users: [],
        }
    },
    mounted(){
        this.get_users();
    },
    methods: {
        get_users(){
            this.axios.get('users/')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.first_name} ${val.last_name}` });
                    });
                })
        },
        submit(){
            if (this.disable == false) {
                const reader = new FileReader();
                reader.readAsDataURL(this.form.file.val);
                reader.onload = () => {
                    const data = new FormData();
                    data.set('base64_file', reader.result.split('base64,')[1]);
                    data.set('file_type', reader.result.split(':').pop().split(';')[0]);
                    data.set('file_name', this.form.file.val.name);
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        text: 'فایل در حال آپلود است. لطفا صبور باشید.'
                    });
                    this.axios.post('upload_file/', data)
                        .then(res => {
                            const data = new FormData();
                            for (const key in this.form){
                                if(key != 'file'){
                                    data.set(key, this.form[key].val);
                                }
                            }
                            data.set('user_id', this.$store.state.user_id)
                            data.set('attachment_id', res.data.id)
                            this.axios.post('user_files/', data)
                                .then(() => {
                                    this.$notify({
                                        group: 'foo',
                                        type: 'success',
                                        text: 'ارسال با موفقیت انجام شد.'
                                    });
                                    for (const key in this.form) {
                                        this.form[key].val = '';
                                    }
                                })
                                .catch(() => {
                                    this.$notify({
                                        group: 'foo',
                                        type: 'error',
                                        text: 'خطا! لطفا مجددا تلاش کنید.'
                                    });
                                })
                        })
                        .catch(() => {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                text: 'خطا! لطفا مجددا تلاش کنید.'
                            });
                        })
                }                    
            }
        }
    },
    beforeCreate() {
        if (this.$store.state.perms.can_add_user_files == false
            && this.$store.state.perms.can_add_user_files_for_same_group_user == false
            && this.$store.state.perms.can_add_user_files_for_all_users == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
